// extracted by mini-css-extract-plugin
export var container = "_9w-0";
export var icon = "_9w-1";
export var text = "_9w-2";